export enum EpiId {
    AsphaltCutters = 436,
    AttachmentFramesTools = 439,
    Buckets = 440,
    SortingBucket = 442,
    TrenchingBucket = 441,
    DiggerBucket = 443,
    GradingBucket = 444,
    Compactors = 435,
    ControlSystems = 1779,
    GradingBeams = 438,
    GrappleModules = 452,
    Grapples = 422,
    SortingGrapples = 427,
    StoneGrapples = 426,
    MultiGrapple = 425,
    MachineFixings = 455,
    QcFixings = 480,
    SFixing = 479,
    RailGrapples = 453,
    Rippers = 437,
    Rototilts = 421,
    R1 = 507,
    R2 = 506,
    R3 = 505,
    R4 = 501,
    R5 = 504,
    RC5 = 1708,
    R6 = 502,
    RC6 = 1709,
    R8 = 503,
    RC9 = 1570,
    Retailer = 182,
    PersonalDataPage = 675,
    Tools = 418
  }
  